/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 15:44:08
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-09-14 17:30:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/OtherInformation/AddInformation/index.tsx
 */
import React, { Fragment, useState, useEffect } from 'react';
import { ModalFooter, TextArea } from 'src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';
import { randomNumber } from '@/src/tools/helper';
import { RefInput } from 'src/components/Antd/Input/Input';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
interface IProps {
  onCancel: () => void;
  onAdd: (value) => void;
  defaultData?: any;
}

const AddInformation = ({ onCancel, onAdd, defaultData }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const titleRef = React.useRef<any>(null);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [contentError, setContentError] = useState(false);
  const [hasModified, setHasModified] = useState(false);
  React.useEffect(() => {
    if (titleRef.current) {
      try {
        titleRef.current.focus();
      } catch (e) {
        console.error(e);
      }
    }
  }, []);
  const onOk = () => {
    onAdd({ title, content, uuid: (defaultData || {}).uuid || randomNumber() });
  };
  useEffect(() => {
    if (defaultData) {
      setTitle(defaultData.title);
      setContent(defaultData.content);
    }
  }, [defaultData]);

  return (
    <Fragment>
      <TopContainer>
        <ItemWrapper
          title={getI18n('general.title')}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <RefInput
            maxLength={100}
            size='large'
            value={title}
            autoFocus
            onChange={(e) => {
              setTitle(e);
              setHasModified(true);
            }}
            error={contentError}
            ref={titleRef}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('general.sider.content') + '*'}
          rightPart={
            <CountWords count={(content || '').length} allCount={500} />
          }>
          <TextArea
            autoSize={{ minRows: 3, maxRows: 10 }}
            maxLength={500}
            size='large'
            value={content}
            onChange={(e) => {
              setContent(e);
              setContentError(false);
              setHasModified(true);
            }}
            error={contentError}
          />
        </ItemWrapper>
      </TopContainer>
      <ModalFooter
        okText={
          defaultData
            ? getI18n('general.saveChanges')
            : getI18n('general.linkModule.Modal.add')
        }
        onOk={onOk}
        onCancel={onCancel}
        hideOkButton={!content || !hasModified}
      />
    </Fragment>
  );
};
export default AddInformation;
